import { Model } from "@vuex-orm/core";

export default class Docage extends Model {
  static get entity() {
    return "docages";
  }
  static fields() {
    return {
      id: this.attr(null),
      sign_date: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
